/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import styled from 'styled-components/native'

import { getLabelColor } from 'ui/designSystem/RadioButton/helpers'
import { RadioStateObject } from 'ui/designSystem/RadioButton/types'
import { Typo } from 'ui/theme'

import { getTextHoverStyle } from '../helpers/hover'

type RadioTextProps = { radioState: RadioStateObject; isHover?: boolean }

export const RadioLabelText = styled(Typo.Body)<RadioTextProps>(
  ({ radioState, theme, isHover }) => ({
    color: getLabelColor({ disabled: radioState.disabled, theme }),
    ...getTextHoverStyle({ radioState, theme, isHover }),
  })
)

export const RadioLabelTextSelected = styled(Typo.BodyAccent)<RadioTextProps>(
  ({ radioState, theme, isHover }) => ({
    color: getLabelColor({ disabled: radioState.disabled, theme }),
    ...getTextHoverStyle({ radioState, theme, isHover }),
  })
)

export const RadioDescriptionText = styled(Typo.BodyXs)<RadioTextProps>(
  ({ radioState, theme, isHover }) => ({
    color: radioState.disabled
      ? theme.designSystem.color.text.disabled
      : theme.designSystem.color.text.default,
    ...getTextHoverStyle({ radioState, theme, isHover }),
  })
)
